import React, { useEffect, useState } from "react";
import { useI18n } from "../../i18n";
import api from "../../api";

const Supplements = ({ profile }) => {
  const { t, lang } = useI18n();
  const [supps, setSupps] = useState([]);

  useEffect(() => {
    api.post("/plan/supplements", profile).then((r) => setSupps(r.data.supplements));
  }, [profile]);

  return (
    <div>
      <div className="mb-6">
        <div className="font-mono text-xs tracking-widest text-white/40 mb-1">// {lang === "ro" ? "PROTOCOL" : "PROTOCOL"}</div>
        <h2 className="font-heading text-3xl text-white">{lang === "ro" ? "Suplimente pe zi" : "Supplements per day"}</h2>
        <div className="font-mono text-[11px] tracking-wider text-white/50 mt-1">
          {lang === "ro" ? "Dozele afișate sunt cantități ZILNICE (nu pe săptămână)." : "Doses shown are DAILY (not weekly)."}
        </div>
      </div>
      <div className="grid md:grid-cols-2 gap-4">
        {supps.map((s) => (
          <div key={s.key} className="sne-card" data-testid={`supp-${s.key}`}>
            <div className="font-mono text-xs tracking-widest text-[#FF3B30] mb-2">{s.key.replace("_", " ").toUpperCase()}</div>
            <h3 className="font-heading text-2xl mb-2">{s[`label_${lang}`] || s.label_en}</h3>
            {(s[`info_${lang}`] || s.info_en) && (
              <div className="mb-4 p-3 text-sm text-white/80" style={{ background: "#1A1A1A", borderLeft: "2px solid #FF3B30" }}>
                <span className="font-mono text-[10px] tracking-widest text-[#FF3B30] mr-2">ℹ INFO</span>
                {s[`info_${lang}`] || s.info_en}
              </div>
            )}
            <Row label="DOSE" value={s[`dose_${lang}`] || s.dose_en} />
            <Row label="TIMING" value={s[`timing_${lang}`] || s.timing_en} />
            <Row label="WHY" value={s[`rationale_${lang}`] || s.rationale_en} />
            {(s[`warning_${lang}`] || s.warning_en) && (
              <div className="mt-3 p-3" style={{ background: "#1F1010", border: "1px solid #FF3B3050" }}>
                <div className="font-mono text-[10px] tracking-widest text-[#FF3B30] mb-1">WARNING</div>
                <div className="text-sm text-white/80">{s[`warning_${lang}`] || s.warning_en}</div>
              </div>
            )}
            {s.medical_required && (
              <div className="mt-3 font-mono text-xs text-amber-400">⚠ MEDICAL TEST REQUIRED</div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

const Row = ({ label, value }) => (
  <div className="mb-3">
    <div className="font-mono text-[10px] tracking-widest text-white/40">{label}</div>
    <div className="text-sm text-white mt-1">{value}</div>
  </div>
);

export default Supplements;
